export default __webpack_public_path__ + "static/media/elss-shark-banner-desktop.2fa1c051.jpg";